import React, { FunctionComponent } from 'react';
import { Typography } from '@rbx/ui';
import { OpenAPI } from '@rbx/docsite-utilities/dist/browser';
import useColoredMethodStyles from './ColoredMethod.styles';

export interface ColoredMethodProps {
  method: OpenAPI.HttpMethod;
}

const ColoredMethod: FunctionComponent<React.PropsWithChildren<ColoredMethodProps>> = ({
  method,
}) => {
  const {
    classes: { get, put, post, delete: deleteStyle, options, head, patch, trace, root, background },
    cx,
  } = useColoredMethodStyles();

  let methodStyle;
  switch (method.toLowerCase()) {
    case 'get':
      methodStyle = get;
      break;
    case 'put':
      methodStyle = put;
      break;
    case 'post':
      methodStyle = post;
      break;
    case 'delete':
      methodStyle = deleteStyle;
      break;
    case 'options':
      methodStyle = options;
      break;
    case 'head':
      methodStyle = head;
      break;
    case 'patch':
      methodStyle = patch;
      break;
    case 'trace':
      methodStyle = trace;
      break;
    default:
      methodStyle = get;
  }

  return (
    <div className={root}>
      <Typography variant='body2' classes={{ root: cx(background, methodStyle) }}>
        {method.toUpperCase()}
      </Typography>
    </div>
  );
};

export default ColoredMethod;
